import React from "react";
import {
  CreditCardOutlined,
  BankOutlined,
  SafetyOutlined,
  IdcardOutlined,
  GiftOutlined,
  WalletOutlined,
  DollarOutlined,
  CustomerServiceOutlined,
  UserOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import type { CategoryConfig } from "../../../types/category";
import { normalizeCategoryConfig } from "../../../types/categoryUtils";
import { DESIGN_ICON_SRC_MAP } from "../v2/icons/designIconMap";

const ANT_ICON_MAP: Record<string, React.ReactNode> = {
  CreditCardOutlined: <CreditCardOutlined />,
  BankOutlined: <BankOutlined />,
  SafetyOutlined: <SafetyOutlined />,
  IdcardOutlined: <IdcardOutlined />,
  GiftOutlined: <GiftOutlined />,
  WalletOutlined: <WalletOutlined />,
  DollarOutlined: <DollarOutlined />,
  CustomerServiceOutlined: <CustomerServiceOutlined />,
  UserOutlined: <UserOutlined />,
  QuestionCircleOutlined: <QuestionCircleOutlined />,
};

interface CategoryIconProps {
  config: CategoryConfig;
  size?: number;
}

const CategoryIcon: React.FC<CategoryIconProps> = ({ config, size = 56 }) => {
  const normalized = normalizeCategoryConfig(config);

  if (normalized.iconType === "design") {
    const presetSrc = DESIGN_ICON_SRC_MAP[normalized.icon];
    if (presetSrc) {
      return (
        <img
          src={presetSrc}
          alt=""
          width={size}
          height={size}
          style={{ display: "block", objectFit: "contain" }}
        />
      );
    }
    if (normalized.icon.startsWith("http")) {
      return (
        <img
          src={normalized.icon}
          alt=""
          width={size}
          height={size}
          style={{ display: "block", objectFit: "contain", borderRadius: 10 }}
        />
      );
    }
  }

  const color = normalized.color || "#1890ff";
  const iconNode = ANT_ICON_MAP[normalized.icon] || <CreditCardOutlined />;

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 10,
        background: `${color}22`,
        border: `1px solid ${color}44`,
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: Math.round(size * 0.45),
      }}
    >
      {iconNode}
    </div>
  );
};

export default CategoryIcon;
